import { useAddToCart } from "repo/cart";
import { useRouter } from "next/router";
import { errorToast } from "@/utils/toast";
import { PET_TAG_DATA } from "@/utils/constants/pet-tag";

function useGetPetTag() {
  const router = useRouter();

  const { isLoading, mutate } = useAddToCart({
    onSuccess: () => {
      router.push("/checkout");
    },
    onError: (error) => {
      errorToast(error.message || "Something went wrong, please try again");
    },
  });

  return {
    isLoading,
    buyTag: () => mutate(PET_TAG_DATA),
  };
}

export default useGetPetTag;
